// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__C831c","progress":"styles_progress__I3meT","overlay":"styles_overlay__BNP3l"};